module.exports = __webpack_public_path__ + "img/tk.62f790ba.png";